import React from 'react';
import { InfoContainer, InfoContent } from './loan-info-card.styled';
export const LoanInfoCard = ({ children, backgroundColor, spacingReduction }) => {
    return (React.createElement(InfoContainer, { spacingReduction: true },
        React.createElement(InfoContent, { backgroundColor: backgroundColor, spacingReduction: true }, children)));
};
//# sourceMappingURL=loan-info-card.js.map